import * as React from 'react';
import classNames from 'classnames';
import {InboundState, InboundStateDisplay} from '../InboundInterfaces';

// This can be extended later to show counts for each status.
interface CountsByStatus {
  [key: string]: number;
}

interface InboundStatusTabsProps {
  selectedStatus: InboundState | null; // `null` represents the "All" tab.
  onStatusSelect: (status: InboundState | null) => void;
  countsByStatus?: CountsByStatus; // Optional: To show counts next to each status.
}

interface StatusTabProps {
  status: InboundState | null;
  displayName: string;
  isSelected: boolean;
  onTabSelect: () => void;
  count?: number;
}

// A reusable sub-component for rendering a single tab.
const StatusTab: React.FC<StatusTabProps> = ({status, displayName, isSelected, onTabSelect, count}) => {
  return (
    <div className="status-tab">
      <button className={classNames('btn', 'btn-default', {activeTab: isSelected})} type="button" onClick={onTabSelect}>
        {/* Conditionally render the status dot, but not for the "All" tab */}
        {status && <span className={`dot ${status}`}></span>}
        {displayName}
        {count != null && <span className="count">{count}</span>}
      </button>
    </div>
  );
};

// 3. Define the order of statuses to be displayed. `null` is used for "All".

const InboundStatusTabs: React.FC<InboundStatusTabsProps> = ({selectedStatus, onStatusSelect, countsByStatus}) => {
  const inboundStates = [null, ...Array.from(InboundStateDisplay.keys())];

  return (
    <div id="inbound-status-tabs">
      <div className="compact-status-tabs">
        {inboundStates.map((status) => {
          // Use the display name from the map, or "All" for the null status.
          const displayName = status ? InboundStateDisplay.get(status) : 'All';
          const key = status || 'all';

          return (
            <StatusTab
              key={`${key}-tab`}
              status={status}
              displayName={displayName}
              isSelected={selectedStatus === status}
              onTabSelect={() => onStatusSelect(status)}
              count={countsByStatus ? countsByStatus[key] : undefined}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InboundStatusTabs;
